// Booking-channel logos for the Welcome step, as SVGs copied from the DMS
// (europea-web: Pages/Reservations/Ch/svg-logos), so the tenant sees the same
// marks the back office does. Vector rather than the PNGs used before: the
// card renders them small on displays that are usually retina, where the
// bitmaps were visibly soft.
//
// Keys match the `channel_name` values the DMS stores, so a reservation
// arriving from it resolves without any mapping in between.
import agoda from "./channel-logos/agoda.svg";
import airbnb from "./channel-logos/airbnb.svg";
import blueground from "./channel-logos/blueground.svg";
import booking from "./channel-logos/booking.com.svg";
import europea from "./channel-logos/europea.svg";
import europearesidences from "./channel-logos/europearesidences.svg";
import expedia from "./channel-logos/expedia.svg";
import google from "./channel-logos/google.svg";
import homelike from "./channel-logos/homelike.svg";
import homesandvillas from "./channel-logos/homesandvillas.svg";
import housinganywhere from "./channel-logos/housinganywhere.svg";
import immoweb from "./channel-logos/immoweb.svg";
import relocation from "./channel-logos/relocation.svg";
import spotahome from "./channel-logos/spotahome.svg";
import travelagency from "./channel-logos/travelagency.svg";
import vrbo from "./channel-logos/vrbo.svg";

export const CHANNEL_LOGOS: Record<string, string> = {
  Airbnb: airbnb,
  Blueground: blueground,
  Booking: booking,
  Europea: europea,
  Expedia: expedia,
  Google: google,
  Homelike: homelike,
  Homesandvillas: homesandvillas,
  HousingAnywhere: housinganywhere,
  Relocate: relocation,
  Spotahome: spotahome,
  TravelAgency: travelagency,
  Vrbo: vrbo,
  Immoweb: immoweb,
  Agoda: agoda,
  "Europea Residential": europearesidences,
};

/** Falls back to null for a channel with no logo, so callers can show the name. */
export const getChannelLogo = (channelName?: string): string | null =>
  (channelName && CHANNEL_LOGOS[channelName]) || null;
